var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-m-bottom-nav',[_c('router-link',{attrs:{"to":{ name: 'home' },"custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isActive = ref.isActive;
var navigate = ref.navigate;
return [_c('u-m-bottom-nav-item',{attrs:{"icon":"mdi-food","active":isActive},on:{"click":navigate}},[_vm._v(" Заявки ")])]}}])}),_c('router-link',{attrs:{"to":{ name: 'monitoring' },"custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isActive = ref.isActive;
var navigate = ref.navigate;
return [_c('u-m-bottom-nav-item',{attrs:{"icon":"mdi-thermometer-low","active":isActive},on:{"click":navigate}},[_vm._v(" Мониторинг ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }